<!-- courseCard -->
<template>
  <div class="courseCard">
    <p class="courseName ellipsis">{{courseInfo.courseName}}</p>
    <ul class="tagList">
      <li v-for="(tag, index) in courseInfo.courseTags" :key="index" class="tagIcon">{{tag}}</li>
    </ul>
    <p class="courseDate">开课时间 {{courseInfo.startDate}} 课时 {{courseInfo.period}}</p>
    <div class="middlePart">
      <ul class="teacherList">
        <li v-for="(teacher, index) in courseInfo.teacherList" :key="index" class="teacherInfo">
          <img src="" alt="" class="teacherPhoto">
          <p class="teacherName">{{teacher.name}}</p>
        </li>
      </ul>
      <p class="pricePart">
        <span class="originalPrice">￥{{courseInfo.originalPrice}}</span>
        <span class="activityPrice">
          {{courseInfo.activityName}}：￥
          <strong class="priceNumber">{{courseInfo.activityPrice}}</strong>
        </span>
      </p>
    </div>
    <div class="bottomPart">
      <p v-if="courseInfo.audition" class="audition">支持试听</p>
      <p class="boughtAmount">{{courseInfo.boughtAmount}}人已购买</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    courseInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {},
};

</script>

<style lang="scss" scoped>
.courseCard {
  position: relative;
  width: 679px;
  // height: 324px;
  padding: 20px 25px 0;
  background: #FFF;
  border-radius: 7px;
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, .03);

  .courseName {
    height: 45px;
    margin-bottom: 9px;
    color: #333;
    font-weight: 500;
    font-size: 33px;
    line-height: 45px;
  }

  .tagList {
    display: flex;
    height: 34px;
    margin-bottom: 11px;

    .tagIcon {
      height: 33px;
      margin-right: 5px;
      padding: 0 13px;
      color: #FE5E18;
      font-weight: 400;
      font-size: 18px;
      line-height: 33px;
      border: 2px solid #FE5E18;
      border-radius: 7px;
    }
  }

  .courseDate {
    height: 31px;
    margin-bottom: 43px;
    color: #A5A5A5;
    font-weight: 400;
    font-size: 22px;
    line-height: 31px;
  }

  .middlePart {
    .teacherList {
      display: flex;

      .teacherInfo {
        width: 63px;
        margin-right: 34px;
        margin-bottom: 9px;

        .teacherPhoto {
          display: flex;
          width: 63px;
          height: 63px;
          border-radius: 50%;
        }

        .teacherName {
          height: 29px;
          color: #A5A5A5;
          font-weight: 400;
          font-size: 20px;
          line-height: 29px;
          text-align: center;
        }
      }
    }

    .pricePart {
      position: absolute;
      right: 31px;
      bottom: 66px;
      color: #FF6C02;
      font-size: 25px;

      .originalPrice {
        color: #A5A5A5;
        font-weight: 400;
        font-size: 22px;
        text-decoration: line-through;
      }
    }
  }

  .bottomPart {
    display: flex;
    justify-content: space-between;
    box-sizing: content-box;
    height: 31px;
    padding: 9px 0 13px;
    font-weight: 400;
    font-size: 22px;
    line-height: 31px;
    border-top: 1px solid rgba(151, 151, 151, .15);

    .audition {
      position: relative;
      height: 31px;
      padding-left: 33px;
      color: #1E87EB;
      font-weight: 400;
      line-height: 31px;

      &::before {
        position: absolute;
        top: 3px;
        left: 0;
        width: 22px;
        height: 22px;
        border: 1px solid #1E87EB;
        border-radius: 50%;
        content: '';
      }

      &::after {
        position: absolute;
        top: 15px;
        left: 13px;
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-right: 0 solid transparent;
        border-bottom: 6px solid transparent;
        border-left: 9px solid #1E87EB;
        border-radius: 2px;
        transform: translate(-50%, -50%);
        content: '';
      }
    }

    .boughtAmount {
      color: #A5A5A5;
      font-weight: 400;
    }
  }
}
</style>
